<template>
    <v-row dense>
        <v-col
                cols="12"
                dense>
            <v-textarea
                    v-model="value"
                    dense
                    solo
                    class="ma-0 py-0"
                    counter="5000"
                    auto-grow
                    :label="field.textarea.placeholder"
                    :error="!!error"
                    :error-messages="error"
                    clearable
                    outlined />
        </v-col>
    </v-row>
</template>

<script>
    import Value from "../../../../../models/value.model";
    import Field from "@/models/field.model";

    export default {
        name: "FieldTextareaComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                value: null,
                error: null,
            }
        },
        watch: {
            value() {
                this.getValue().then((value) => {
                    this.$emit('updateValue', value);
                })
            }
        },
        mounted() {
            this.value = this.field.value.value;
        },
        methods: {
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                const value = new Value({
                    value: this.value,
                    isValid: true
                });
                
                if (!this.field.is_optional && value.isEmpty) {
                    this.error = 'Mandatory field';
                } else if (!value.isEmpty) {
                    if (this.isValid() === true) {
                        value.isValid = true;
                        this.error = null;
                    } else {
                        this.error = this.isValid();
                    }
                }

                if (this.error) {
                    value.isValid = false;
                    value.error = this.error;
                }
                
                return value;
            },
            isValid() {
                return this.value.length <= 5000 || 'The value may not be greater than 5000 characters.';
            },
        }
    }
</script>

<style scoped>
	.maz-input__input {
		height: 56px !important;
	}
</style>